var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.reports},on:{"on-row-click":_vm.printReport}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }